'use server';

import { signIn } from '@/lib/auth/auth';
import { prisma } from '@/lib/db/prisma';
import bcrypt from 'bcryptjs';
import { redirect } from 'next/navigation';
import { z } from 'zod';

// ── Login ────────────────────────────────────────────────────
export async function loginAction(formData: FormData) {
  const email    = formData.get('email')    as string;
  const password = formData.get('password') as string;

  try {
    await signIn('credentials', { email, password, redirectTo: '/generate' });
  } catch (error: unknown) {
    const msg = error instanceof Error ? error.message : '';
    if (msg.includes('CredentialsSignin') || msg.includes('credentials')) {
      return { error: 'Hibás email vagy jelszó.' };
    }
    throw error; // redirect-et újradobjuk
  }
}

// ── Register ─────────────────────────────────────────────────
const RegisterSchema = z.object({
  name:     z.string().min(2, 'A név legalább 2 karakter legyen.'),
  email:    z.string().email('Érvénytelen email cím.'),
  password: z.string().min(8, 'A jelszó legalább 8 karakter legyen.'),
});

export async function registerAction(formData: FormData) {
  const parsed = RegisterSchema.safeParse({
    name:     formData.get('name'),
    email:    formData.get('email'),
    password: formData.get('password'),
  });

  if (!parsed.success) {
    return { error: parsed.error.errors[0].message };
  }

  const existing = await prisma.user.findUnique({
    where: { email: parsed.data.email },
  });
  if (existing) {
    return { error: 'Ez az email cím már foglalt.' };
  }

  const passwordHash = await bcrypt.hash(parsed.data.password, 12);

  await prisma.user.create({
    data: {
      name:         parsed.data.name,
      email:        parsed.data.email,
      passwordHash,
    },
  });

  redirect('/login?registered=1');
}
